import styled from 'styled-components';

export const CylinderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: -400;
  overflow: hidden;
  
  /* Flat layout - no 3D perspective */
  opacity: ${props => props.$opacity};
  
  /* Center the columns and ensure full coverage */
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Ensure the container covers the full viewport */
  min-width: 100vw;
  min-height: 100vh;
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    /* Reduce opacity on mobile for better readability */
    opacity: ${props => props.$opacity * 0.7};
  }
  
  @media (max-width: 480px) {
    /* Further reduce on small mobile screens */
    opacity: ${props => props.$opacity * 0.5};
  }
`;

export const Column = styled.div`
  position: absolute;
  width: ${props => props.$width}px;
  height: ${props => props.$height}px;
  
  /* Center columns evenly from the middle */
  left: ${props => props.$x}%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%); /* Center both horizontally and vertically */
  
  /* No spacing between columns */
  margin: 0;
  
  /* Add padding to prevent shadow clipping */
  padding: 40px 40px;
  
  /* Performance optimizations */
  will-change: transform;
  backface-visibility: hidden;
  
  /* Vertical scrolling container */
  overflow: hidden;
`;

export const CardDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.$width}px;
  height: ${props => props.$height}px;
  
  /* Simple card styling */
  border: 1px solid rgba(255, 255, 255, 0.0 5);
  border-radius: 8px;
  box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.2);
  
  /* Performance optimizations */
  will-change: transform;
  backface-visibility: hidden;
  
  /* Gap between cards in column */
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    /* Reduce border radius and shadow on mobile */
    border-radius: 6px;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.2);
    margin-bottom: 15px;
  }
  
  @media (max-width: 480px) {
    /* Further reduce on small screens */
    border-radius: 4px;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.2);
    margin-bottom: 10px;
  }
`;
